import { render } from "./PersonalDataScreen.vue?vue&type=template&id=17512af0&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=17512af0&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17512af0"]])

export default __exports__